import { render, staticRenderFns } from "./widget-dropdown.vue?vue&type=template&id=6fc72f48&"
import script from "./widget-dropdown.vue?vue&type=script&lang=js&"
export * from "./widget-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./widget-dropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports